import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessTrinityExportStatus: 'idle',
    startProcessTrinityExportError: undefined as any,
    loadUserParamsProcessTrinityExportStatus: 'idle',
    loadUserParamsProcessTrinityExportError: undefined as any,

    processTrinityExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessTrinityExport = createAsyncThunk('processTrinityExportSlice/startProcessTrinityExport', async ({ processTrinityExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessTrinityExport/`,
        prepareData(processTrinityExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessTrinityExportStatus } = getState().processTrinityExportSlice
        return startProcessTrinityExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessTrinityExport = createAsyncThunk('processTrinityExportSlice/loadUserParamsProcessTrinityExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessTrinityExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessTrinityExportStatus } = getState().processTrinityExportSlice
        return loadUserParamsProcessTrinityExportStatus !== 'pending'
    }
})

const ProcessTrinityExportSlice = createSlice({
    name: 'processTrinityExportSlice',
    initialState,
    reducers: {
        resetstartProcessTrinityExport: (state) => {
            state.job = undefined
            state.startProcessTrinityExportError = undefined
        },
        resetstartProcessTrinityExportError: (state) => {
            state.startProcessTrinityExportError = undefined
        },
        resetloadUserParamsProcessTrinityExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessTrinityExportError = undefined
        },
        resetloadUserParamsProcessTrinityExportError: (state) => {
            state.loadUserParamsProcessTrinityExportError = undefined
        },
        removeFromProcessTrinityExportListById: (state, action) => {
            state.processTrinityExportList = state.processTrinityExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessTrinityExportListByIds: (state, action) => {
            state.processTrinityExportList = state.processTrinityExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processTrinityExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessTrinityExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processTrinityExportList = []
            state.startProcessTrinityExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessTrinityExport.pending, (state) => {
            state.startProcessTrinityExportStatus = 'pending'
            state.startProcessTrinityExportError = undefined
        })
        builder.addCase(startProcessTrinityExport.fulfilled, (state, action) => {
            state.startProcessTrinityExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessTrinityExport.rejected, (state, action) => {
            state.startProcessTrinityExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessTrinityExportError = action.error.message
            } else {
                state.startProcessTrinityExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessTrinityExport.pending, (state) => {
            state.loadUserParamsProcessTrinityExportStatus = 'pending'
            state.loadUserParamsProcessTrinityExportError = undefined
        })
        builder.addCase(loadUserParamsProcessTrinityExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessTrinityExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessTrinityExport.rejected, (state, action) => {
            state.loadUserParamsProcessTrinityExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessTrinityExportError = action.error.message
            } else {
                state.loadUserParamsProcessTrinityExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessTrinityExport,
    resetstartProcessTrinityExportError,
    resetloadUserParamsProcessTrinityExport,
    resetloadUserParamsProcessTrinityExportError,
    removeFromProcessTrinityExportListById,
    removeFromProcessTrinityExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessTrinityExportSlice.actions
export default ProcessTrinityExportSlice.reducer
